/**
 * Centralized domain configuration for multi-TLD support.
 * Uses envalid for environment variable validation with tryfi.com defaults.
 */

import { cleanEnv, str, bool } from 'envalid';

// Vite exposes env vars on import.meta.env
const rawEnv = import.meta.env;

const env = cleanEnv(rawEnv, {
  VITE_SITE_DOMAIN: str({ default: 'nano.tryfi.com' }),
  VITE_MARKETING_SITE: str({ default: 'https://tryfi.com' }),
  VITE_SHOP_URL: str({ default: 'https://shop.tryfi.com' }),
  VITE_SUPPORT_URL: str({ default: 'https://support.tryfi.com' }),
  VITE_BLOG_URL: str({ default: 'https://blog.tryfi.com' }),
  VITE_SUPPORT_EMAIL: str({ default: 'support@tryfi.com' }),
  VITE_BLOCK_ROBOTS: bool({ default: true }),
  VITE_SESSION_COOKIE_DOMAIN: str({ default: '' }),
});

export interface DomainConfig {
  // Base configuration from environment variables
  siteDomain: string;
  marketingSite: string;
  shopUrl: string;
  supportUrl: string;
  blogUrl: string;
  supportEmail: string;
  blockRobots: boolean;
  sessionCookieDomain: string;

  // Computed/derived URLs
  contactUrl: string;
  accessoriesUrl: string;
  storiesUrl: string;
  techUrl: string;
  collarUrl: string;
  appUrl: string;
  reviewsUrl: string;
  shopProductsUrl: string;
  supportHelpCenterUrl: string;
  marketingSiteHostname: string;
}

export const domainConfig: DomainConfig = {
  // Base configuration from validated env vars
  siteDomain: env.VITE_SITE_DOMAIN,
  marketingSite: env.VITE_MARKETING_SITE,
  shopUrl: env.VITE_SHOP_URL,
  supportUrl: env.VITE_SUPPORT_URL,
  blogUrl: env.VITE_BLOG_URL,
  supportEmail: env.VITE_SUPPORT_EMAIL,
  blockRobots: env.VITE_BLOCK_ROBOTS,
  sessionCookieDomain: env.VITE_SESSION_COOKIE_DOMAIN,

  // Derived URLs
  contactUrl: `${env.VITE_SUPPORT_URL}/hc/en-us/requests/new`,
  accessoriesUrl: `${env.VITE_SHOP_URL}/accessories`,
  storiesUrl: `${env.VITE_MARKETING_SITE}/stories`,
  techUrl: `${env.VITE_MARKETING_SITE}/learn`,
  collarUrl: `${env.VITE_MARKETING_SITE}/collar`,
  appUrl: `${env.VITE_MARKETING_SITE}/theapp`,
  reviewsUrl: `${env.VITE_MARKETING_SITE}/reviews`,
  shopProductsUrl: `${env.VITE_SHOP_URL}/products/`,
  supportHelpCenterUrl: `${env.VITE_SUPPORT_URL}/hc/en-us`,
  marketingSiteHostname: new URL(env.VITE_MARKETING_SITE).hostname,
};
